import React from "react";
import {Link} from 'react-router-dom';
class Forgot extends React.Component{
  render() {
    return (
      <div class="container login-box d-flex justify-content-center align-items-center">
    <div class="container col-md-4">
      <div>
      <img src={process.env.PUBLIC_URL + '/logo512.png'} alt="Logo" className="logo"/>
      </div>
        <h1 className="text-center title">BELLWOOD</h1>
        <h3 className="text-center sub-title">INVESTMENTS LLC</h3>
      <form action="/action_page.php">
          <div className="text-center">
              <h3 className="input-lable">Forgot?</h3>
          </div>
          <div className="text-center font-weight-bolder">
              <Link to="/forgotUsername" className="link-colour forgot-link">Username</Link><br/><br/>
              <Link to="/forgotPassword" className="link-colour forgot-link">Password</Link><br/><br/>
              <Link to="/" className="link-colour back-login">Back to login</Link>
          </div>
  
          </form>
          </div></div>
  
    );
  }
}


export default Forgot;